import "./admit.css";

export default function Admit() {

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;

    const whatsappMessage = `
*New Appointment Request*

👤 Name: ${form.name.value}
📞 Phone: ${form.phone.value}
🎂 Age: ${form.age.value || "N/A"}
📧 Email: ${form.email.value}
💼 Profession: ${form.profession.value}
🛠 Service: ${form.service.value}
👥 Profile: ${form.profile.value}
📝 Message: ${form.message.value || "N/A"}
    `;

    window.open(
      "https://wa.me/7200039384?text=" +
        encodeURIComponent(whatsappMessage),
      "_blank"
    );

    form.reset();
  };

  return (
    <section className="admit-section">
      <div className="admit-container">

        {/* ABOUT US */}
        <div className="about-box">
          <h2 className="section-title">About Us</h2>

          <p className="about-text">
            At Aerlis Gro, we believe that wealth is not just about money—it’s about
            security, freedom, and a future you can trust. As a modern wealth
            management company, we provide personalized financial solutions.
          </p>

          <p className="about-text">
            AERLIS GRO IMF PVT LTD delivers trusted financial solutions under one roof.<br></br>

Insurance: Life, Health & General Insurance for complete protection<br></br>

Loans: Personal, Home, Business, Commercial, Education & Vehicle Loans<br></br>

Investments: Mutual Funds & Systematic Investment Plans (SIP) for smart wealth creation <br></br>

Secure,Grow,Prosper. <br></br>

We help you protect what matters and build a stronger financial future.
          </p>
          <p className="about-text">

Our experienced employee deliver transparent, goal-oriented wealth planning services tailored to your lifestyle and long-term vision.
          </p>

          <div className="tagline">Be Sure with Aerlis Gro</div>

          <div className="about-image">
            <img src="/aboutuss.jpg" alt="About Us" />
          </div>
        </div>

        {/* FIX APPOINTMENT */}
        <div className="form-box">
          <h2 className="section-title">Fix Appointment</h2>

          <form className="appointment-form" onSubmit={handleSubmit}>
            <input name="name" placeholder="Full Name*" required />
            <input name="phone" placeholder="Phone Number*" required />
            <input name="age" placeholder="Age" />
            <input name="email" placeholder="Email Address*" required />

            {/* NEW INPUT */}
            <input name="profession" placeholder="Profession*" required />

            <select name="service" required>
              <option value="">Select Service</option>
              <option>Life Insurance</option>
              <option>Health Insurance</option>
              <option>General Insurance</option>
              <option>Personal Loan</option>
              <option>Home Loan</option>
              <option>Auto Loan</option>
              <option>Mutual Fund</option>
              <option>SIP</option>
            </select>

            <select name="profile" required>
              <option value="">Select Profile</option>
              <option>Single</option>
              <option>Married (No Kids)</option>
              <option>With Kids</option>
              <option>Working Women</option>
              <option>Self Employed</option>
            </select>

            <textarea name="message" placeholder="Message (Optional)" />

            <button type="submit">Book Appointment</button>
          </form>
        </div>

      </div>
    </section>
  );
}
